import loan from "./loan.component";
import loanUrls from "./loan.urls";
import LoanTransforms from "./loan.transforms";

const loanModule = angular
  .module("app.components.loan", [])
  .component("loanPage", loan)
  .service("LoanTransforms", LoanTransforms)
  .config(loanUrls);

export default loanModule;



// WEBPACK FOOTER //
// ./src/pages/loan/loan.module.js